module.exports = __webpack_public_path__ + "static/img-main-e18c267fdcca6dab07b27a199b21cce7.jpg";